import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  bcpSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  helpTooltip,
} from 'app/components/global';

import controller from './upload-schematics-dialog.controller';
import template from './upload-schematics-dialog.html';
import schematicFileMessagesTpl from '../messages/schematic.file.messages.html';
import schematicNameMessagesTpl from '../messages/schematic.name.messages.html';
import schematicSectionMessagesTpl from '../messages/schematic.section.messages.html';

class dialogService {
  getOptions($event, {
    customerId, assessmentId, schematicSectionId
  }) {
    return {
      controller,
      controllerAs: 'uploadSchematicsDialogVM',
      locals: {
        customerId,
        assessmentId,
        schematicSectionId,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.uploadSchematicsDialog', [
  alerts,
  bcpDataService,
  bcpSharedModelService,
  constants,
  helpTooltip,
  loaderService,
  ssDialogService,
])
  .service('uploadSchematicsDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('schematic.name.messages.html', schematicNameMessagesTpl);
    $templateCache.put('schematic.section.messages.html', schematicSectionMessagesTpl);
    $templateCache.put('schematic.file.messages.html', schematicFileMessagesTpl);
  })
  .name;
